import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Modal, ModalConfig, ModalType, NonPersistedModalName } from '@shared/models/modal.model';
import { EventManager } from '@app/shared/utils/event-manager';
import { LoggerService } from '@app/shared/services/logger.service';
import { environment } from '@environments/environment';
import { SharedModule } from '@app/shared/shared.module';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { DividerComponent } from '@app/shared/components/divider/divider.component';

@Component({
  selector: 'slotcom-account-deletion-step1',
  templateUrl: './account-deletion-step1.component.html',
  styleUrls: ['./account-deletion.component.scss'],
  standalone: true,
  imports: [SharedModule, ButtonComponent, DividerComponent],
})
// eslint-disable-next-line
export class AccountDeletionStep1 {
  logger = inject(LoggerService);
  private eventManager = inject(EventManager);
  data = inject<ModalConfig>(MAT_DIALOG_DATA);

  deactivationDays: number = environment.accountDeletionDays;

  stepForward() {
    this.closeModal();
    this.eventManager.openModal(
      new Modal(NonPersistedModalName.AccountDeletionStep2, ModalType.View, this.deactivationDays, 'default')
    );
  }

  closeModal() {
    this.eventManager.closeModal(new Modal(NonPersistedModalName.AccountDeletionStep1, ModalType.View));
  }
}
